import { REACTIVE } from '../flags'

import type { Reactive } from '../types'
import type { TMap } from '@rehaje/shared'

export function addParent(parent: any, key: number | string, child: any): void
export function addParent(
  parent: Reactive,
  key: number | string,
  child: Reactive
): void {
  if (!(child?.__rr_flags & REACTIVE)) return
  let map: TMap<string[]> | undefined
  let array: string[] | undefined
  array = (map = child.__rr_parents)?.get(parent)
  if (typeof key !== 'string') key = String(key)
  if (array?.includes(key)) return
  if (map === undefined) child.__rr_parents = map = new Map()
  if (array === undefined) map.set(parent, (array = []))
  array.push(key)
}

export function removeParent(
  parent: Reactive,
  key: number | string,
  child: Reactive
): void {
  if (!(child?.__rr_flags & REACTIVE)) return
  if (typeof key !== 'string') key = String(key)
  const array = child.__rr_parents?.get(parent)
  const index = array?.indexOf(key) ?? -1
  if (array !== undefined && index !== -1) array.splice(index, 1)
}
